var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgNergieImpact = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 84.32 85.41",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-5",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5,
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#081221",
    floodOpacity: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.37,30.06c-.45-4.02-2.08-7.88-4.74-11.18-2.58-3.21-5.95-5.62-9.75-6.98l-.36-.13c-7.19-2.58-15.63-1.12-21.49,3.72-6.51,5.37-9.37,14.5-7.12,22.7.17.62.38,1.26.64,1.94l-7.74,21.59,4.66,1.67-1.21,3.39,22.58,8.09,1.21-3.39,4.66,1.67,7.73-21.58c.13-.08.26-.15.38-.23,3.54-2.13,6.42-5.29,8.33-9.12,1.9-3.81,2.66-8.02,2.19-12.19Z",
    fill: "#ffce00",
    filter: "url(#drop-shadow-5)",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7,30.8c-.31-2.82-1.52-5.51-3.3-7.71-1.81-2.25-4.25-4.01-6.99-4.94-5.02-1.86-10.99-.89-15.13,2.53-4.49,3.7-6.46,10.16-4.92,15.76.5,1.81,1.42,3.45,2.09,5.19.63,1.66,1.01,3.68.06,5.3,0,0,0,0,0,0l-2.91-1.04-1.31,3.65-.3.85-1,2.8-.3.85-1.31,3.65,4.66,1.67-1.21,3.39,9.97,3.57,1.21-3.39,4.66,1.67,1.31-3.65.3-.85,1-2.8.3-.85,1.31-3.65-2.91-1.04s0,0,0,0c.55-3.49,4.8-4.57,7.38-6.12,2.51-1.52,4.48-3.75,5.79-6.37,1.3-2.6,1.85-5.57,1.53-8.46ZM38.09,64.81l-7.74-2.77.82-2.28,7.74,2.77-.82,2.28ZM43.96,63.09l-3.55-1.27-9.97-3.57-3.55-1.27.82-2.28,17.07,6.12-.82,2.28ZM46.09,57.16l-.82,2.28-17.07-6.12.82-2.28,17.07,6.12ZM46.58,55.79l-17.07-6.12.82-2.28,17.07,6.12-.82,2.28ZM52.47,44.68c-2.95,1.67-6.88,2.93-7.68,6.63l-11.06-3.96c1.49-2.91.03-6.04-1.2-8.78-1.19-2.68-1.66-5.47-1.2-8.38.43-2.72,1.67-5.36,3.55-7.38,1.86-1.99,4.34-3.35,6.99-3.95,2.35-.53,4.79-.49,7.1.16.04.02.09.04.15.06.3.08.6.18.9.28.09.03.18.07.28.1.03.01.05.02.08.03.17.07.33.14.5.21.05.02.1.04.15.05,4.34,1.91,7.64,6.04,8.35,10.77.83,5.52-2.05,11.41-6.91,14.16Z",
    fill: "#252544",
    strokeWidth: 0
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNergieImpact);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Énergie impact.08760a90781e5f182b811967dd07341f.svg";